import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login/Login.vue'
import LoginH5 from '../views/H5/LoginH5.vue'
import { isMobile } from '@/utils/device'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/login'
  },
  ////////////////////////////////////PC端///////////////////////////////////////////
  {
    path: '/mailbox',
    name: 'mailbox',
    meta: {
      requireAuth: true,
      name: '我要写信'
    },
    component: () => import('../views/MailBoxWx.vue')
  },
  {
    path: '/client',
    name: 'client',
    meta: {
      requireAuth: true,
      name: '信件查询'
    },
    component: () => import('../views/letter/ClientWx.vue')
  },
  {
    path: '/detail',  //信件详情
    name: 'detail',
    meta: {
      requireAuth: true,
      name: '信件详情'
    },
    component: () => import('../views/letter/Detail.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },

  /////////////////////////////////H5////////////////////////////////
  {
    path: '/H5/mailbox',
    name: 'mailbox_H5',
    meta: {
      requireAuth: true,
      name: '局长信箱',
    },
    component: () => import('../views/H5/MailBoxH5.vue')
  },
  {
    path: '/H5/client',
    name: 'client_H5',
    meta: {
      requireAuth: true,
      name: '信件查询'
    },
    component: () => import('../views/H5/ClientH5.vue')
  },
  // {
  //   path: '/H5/detail',  //信件详情
  //   name: 'detail_H5',
  //   meta: {
  //     requireAuth: true,
  //     name: '信件详情'
  //   },
  //   component: () => import('../views/H5/DetailH5.vue')
  // },
  {
    path: '/H5/login',
    name: 'login_H5',
    component: LoginH5
  },

  //////////////////////////////通用////////////////////////////////
  {
    path: '/404',
    name: '404',
    component: () => import('../views/error-page/404.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    name: 'Any'
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 前置导航守卫
router.beforeEach((to,from,next) => {
  let path = to.path 
  //判断PC还是H5
  let isMobileFlag = isMobile()

  if (to.meta.requireAuth) {  // 判断跳转的路由是否需要登录
    const token = localStorage.getItem('USER_TOKEN_STORAGE')  // 获取token
    if (token && token != '') { // 已登录
      next()
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }   
  
  // 通用异常界面 放行
  if(path.includes('404')) {
    next()
  }
  if(isMobileFlag && !path.includes('/H5')) { // 是移动端
    path = `/H5${path}`
    next(path)
  }else if(!isMobileFlag && path.includes('/H5')) {
    path = path.split('/H5')[1]
    next(path)
  }else {
    next()
  }
})

export default router
